import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { addProducts } from '../../services/internal/add-products-service'

export const addProductsAction = createAsyncThunk(
  'addProducts/add',
  async (data: { request; isCFProduct }) => {
    const { request, isCFProduct } = data
    return await addProducts({ request, isCFProduct })
  },
)

const initialState = {
  plans: [],
  isAddingProducts: false,
  isFetchingPlans: false,
}

const addProductsSlice = createSlice({
  name: 'addProducts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(addProductsAction.pending, state => {
        state.isAddingProducts = true
      })
      .addCase(addProductsAction.fulfilled, state => {
        state.isAddingProducts = false
      })
      .addCase(addProductsAction.rejected, state => {
        state.isAddingProducts = false
      })
  },
})

export default addProductsSlice.reducer
